module.exports = __webpack_public_path__ + "static/media/overview_db.b99df86f.png";